namespace $.$$ {

	$mol_style_define( $shm_ba_report_renderer, {
		flex: {
			grow: 1,
			shrink: 1,
		},
		minWidth: 0,
	} )

}
